import Vue from 'vue';
import Router from 'vue-router';
import configService, { getErrorStatus } from './services/config';

Vue.use(Router);

function fromBinary(encoded) {
  
  const binary = Buffer.from(encoded, 'base64').toString();
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < bytes.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return String.fromCharCode(...new Uint16Array(bytes.buffer));
}

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/BuyPhones.vue'),
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue'),
    },
    {
      path: '/buyout/create',
      name: 'createBuyout',
      props: true,
      component: () => import('./views/BuyoutCreate.vue'),
    },
    {
      path: '/orders',
      name: 'orders',
      component: () => import('./views/Orders.vue'),
    },
    {
      path: '/buy-phones',
      name: 'buy-phones',
      component: () => import('./views/BuyPhones.vue'),
    },
    {
      path: '/apple-watch',
      name: 'apple-watch',
      component: () => import('./views/Applewatch.vue'),
    },
    {
      path: '/stores',
      name: 'stores',
      component: () => import('./views/Stores'),
    },
    {
      path: '/stores/:id',
      name: 'store',
      component: () => import('./views/Store'),
    },
    {
      path: '/summary',
      name: 'summary',
      component: () => import('./views/Summary'),
    },
    {
      path: '/ransoms',
      name: 'ransoms',
      component: () => import('./views/Ransoms'),
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});

const clearAuthSession = () => {
  Vue.$storage.remove('token');
  Vue.$storage.remove('user-info');
  configService.clear();
};

const preloadScoringConfig = async user => {
  if (!user || user.type !== 1) return true;

  try {
    await configService.preload();
    return true;
  } catch (error) {
    if (getErrorStatus(error) === 401) {
      clearAuthSession();
      return false;
    }
    return true;
  }
};

router.beforeEach(async (to, from, next) => {
  if(to.query.token){
    
    const result = JSON.parse(fromBinary(Buffer.from(to.query.token, 'base64').toString()))
    Vue.$storage.set('token', result.key);
    Vue.$storage.set('extOrderId', result.extOrderId);
    Vue.$storage.set('order-data', result.data);
    if (result && result.user){
      Vue.$storage.set('flowType', result.user.flowType);
    }
    if (result.contractId){
      Vue.$storage.set('contractId', result.contractId);
    }
    Vue.$storage.set('user-info', result.user);
    configService.clear();

    if (!(await preloadScoringConfig(result.user))) {
      next({ name: 'login' });
      return;
    }

    next({ name: 'buy-phones', query: {"verification": result.user.verification, "contractId": result.contractId} });
    return;
  }
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = Vue.$storage.get('token');

  if (authRequired && !loggedIn) {
    if(to.query.login && to.query.password){
      Vue.$storage.set('login',to.query.login);
      Vue.$storage.set('password',to.query.password);
    }
    next({ name: 'login' });
    return
    // return next('/login');
  }

  if (authRequired) {
    const user = Vue.$storage.get('user-info');
    if (!(await preloadScoringConfig(user))) {
      next({ name: 'login' });
      return;
    }
  }

  return next();
});

export default router;
